import React from 'react';
import PropTypes from 'prop-types';
import CommonTabs from '../commonTabs';

const UsersTab = ({ value }) => (
  <CommonTabs
    value={value}
    tabs={[
      { value: "international", labelId: "navbar.users.international", to: "/external/users-international" },
      { value: "france", labelId: "navbar.users.france", to: "/external/users" },
      { value: "onedata", labelId: "navbar.users.onedata", to: "/external/users_onedata" },
      { value: "monitoring", labelId: "navbar.users.monitoring", to: "/external/users_monitoring" },
    ]}
  />
);

UsersTab.propTypes = {
  value: PropTypes.any,
};

export default UsersTab;
